import "../css/landing.css";
import logo from "../geuzenetlog.png";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import {
  AssetsSelect,
  AssetsTextInput2,
  MemoAssetsDatePicker,
  AssetsDateTimePicker,
} from "../components/assetsInputs";
import { selectAppUser } from "../store/selectors/navigation";
import { selectQuickSearch } from "../store/selectors/quickSearch";

import { getAppUser } from "../store/actions/navigation";
import { getSearchData, setKeyword } from "../store/actions/quickSearch";

function LandingPage() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAppUser());
  }, [dispatch]);

  let frontUser;
  const appUser = useSelector(selectAppUser);
  if (appUser) {
    if (appUser.userDetails) {
      frontUser = `${appUser.userDetails.charAt(0).toUpperCase()}${
        appUser.userDetails.slice(1).split("@")[0]
      }`;
    }
  }

  useEffect(() => {
    if (appUser) {
      if (appUser.userRoles) {
        console.log(appUser.userRoles);
        console.log(appUser.userRoles.includes("user", "admin", "inst"));
        if (
          appUser.userRoles.includes("user") ||
          appUser.userRoles.includes("admin")
        ) {
          dispatch(getSearchData());
        }
      }
    }
  }, [dispatch, appUser]);
  const quickSearchData = useSelector(selectQuickSearch);
  const highLightFunc = (text) => {
    if (text) {
      if (text.length > 0) {
        if (
          quickSearchData.keyword === "" ||
          quickSearchData.keyword.length < 3
        )
          return <>{text}</>;
        if (!text.toUpperCase().includes(quickSearchData.keyword.toUpperCase()))
          return <>{text}</>;
        const partsUp = text
          .toUpperCase()
          .split(quickSearchData.keyword.toUpperCase());
        let j = 0;

        return partsUp.map((part, i) => {
          j = j + part.length;
          if (i === 1 && part === " ") {
            console.log(i, part);
          }
          if (i === partsUp.length - 1)
            return (
              <>
                {text.slice(
                  text.toUpperCase().indexOf(part),
                  text.toUpperCase().indexOf(part) + part.length,
                )}
              </>
            );

          if (i > 0 && part.length === 0)
            return (
              <>
                {text.slice(
                  text.toUpperCase().indexOf(part),
                  text.toUpperCase().indexOf(part) + part.length,
                )}
                <mark>
                  {text.slice(
                    text.toUpperCase().indexOf(part) + part.length + i,
                    text.toUpperCase().indexOf(part) +
                      part.length +
                      quickSearchData.keyword.length +
                      i,
                  )}
                </mark>
              </>
            );
          return (
            <>
              {text.slice(
                text.toUpperCase().indexOf(part),
                text.toUpperCase().indexOf(part) + part.length,
              )}
              <mark>
                {text.slice(
                  text.toUpperCase().indexOf(part) + part.length,
                  text.toUpperCase().indexOf(part) +
                    part.length +
                    quickSearchData.keyword.length,
                )}
              </mark>
            </>
          );
        });
      }
    }
  };

  return (
    <div className="body">
      <div className="LandingPage">
        <h1>{frontUser ? `Welcome ${frontUser}.` : ""}</h1>
        {quickSearchData.servicesQS.length > 0 ? (
          <div className="quickSearch">
            <div>
              <AssetsTextInput2
                onChangeFunc={(value) => {
                  dispatch(setKeyword(value));
                }}
              />
            </div>
            {quickSearchData.keyword.length > 0 ? (
              <div className="quickSearchResults">
                <div className="quickSearchResultsColumnA">
                  <div className="quickSearchServices">
                    <div className="quickSearchResultsHeader">Services</div>
                    <div className="quickSearchServicesList">
                      {quickSearchData.servicesQS
                        .filter((service) =>
                          `${service.id} ${service.userName} ${
                            service.userAddress
                          } ${service.customerName} ${
                            service.agentName
                          } ${service.assignedDevices.join(" ")}`
                            .toUpperCase()
                            .includes(quickSearchData.keyword.toUpperCase()),
                        )
                        .map((service) => (
                          <div
                            className="quickSearchServicesEntry"
                            onClick={(e) =>
                              window.open(`/serviceDetails/${service.id}`)
                            }
                          >
                            <div>
                              <b>{highLightFunc(service.id)}</b>
                            </div>
                            <div>{highLightFunc(service.userName)}</div>
                            <div>{highLightFunc(service.userAddress)}</div>
                            <div>{highLightFunc(service.customerName)}</div>
                            <div>{highLightFunc(service.agentName)}</div>
                            <div>
                              {service.assignedDevices.map((dev) => {
                                return highLightFunc(`${dev} `);
                              })}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                  <div className="quickSearchContracts">
                    <div className="quickSearchResultsHeader">Contracts</div>
                    <div className="quickSearchContractsList">
                      {quickSearchData.contractsQS
                        .filter((contract) =>
                          `${contract.contractId} ${contract.customerName} ${contract.twinfieldId}`
                            .toUpperCase()
                            .includes(quickSearchData.keyword.toUpperCase()),
                        )
                        .map((contract) => (
                          <div
                            className="quickSearchContractsEntry"
                            onClick={(e) =>
                              window.open(
                                `/InvoicingContracts/${contract.contractId}`,
                              )
                            }
                          >
                            <div>
                              <b>{highLightFunc(contract.contractId)}</b>
                            </div>
                            <div>
                              {highLightFunc(
                                `${contract.customerName} (${
                                  contract.twinfieldId
                                    ? contract.twinfieldId
                                    : "-"
                                })`,
                              )}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
                <div className="quickSearchResultsColumnB">
                  <div className="quickSearchDevices">
                    <div className="quickSearchResultsHeader">Devices</div>
                    <div className="quickSearchDevicesList">
                      {quickSearchData.assetsQS
                        .filter((tag_id) =>
                          tag_id
                            .toUpperCase()
                            .includes(quickSearchData.keyword.toUpperCase()),
                        )
                        .map((tag_id) => (
                          <div
                            className="quickSearchDevicesEntry"
                            onClick={(e) =>
                              window.open(`/hardwareDetails/${tag_id}`)
                            }
                          >
                            <div>
                              <b>{highLightFunc(tag_id)}</b>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        ) : appUser.userRoles &&
          (appUser.userRoles.includes("firecell") ||
            appUser.userRoles.includes("inst")) ? (
          <div>
            <p>Use navigation to continue.</p>
            <img className="landingLogo still" src={logo} alt="company logo" />
          </div>
        ) : (
          <div>
            <p>Log in to continue.</p>
            <img className="landingLogo still" src={logo} alt="company logo" />
          </div>
        )}
      </div>
    </div>
  );
}

export default LandingPage;
